<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B23M2C/tc-custom/9780253028396.jpg?1737778272987" alt="This image is the cover for the book Writings and Letters of Konrad Wolff"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Writings and Letters of Konrad Wolff
      </h1>
      <p class="bookDescription body article font2">
        <p>"[Wolff] is a remarkable pianist, an excellent theoretician, a learned teacher, a brilliant thinker and writer." —Artur Schnabel</p><p>"This collection of [Wolff's] writings and letters should bear ample testimony to a musician who happily combined the artist, the teacher, the musicologist, and the charm and integrity of a human being." —Alfred Brendel</p><p>"Konrad Wolff writes about music with the verve and enthusiasm of a great teacher who has never lost his sense of music as an adventure. To read him is to enter into a lively dialogue with a superior musical mind and a buoyant spirit." —Richard Goode</p><p>This collection provides elegant and thorough portraits of an important 20th-century performer and lover of music, as well as of his greatest influences.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Gillen, Leon Fleisher, Russell Sherman
      </h2>
      
      <p class="authorDescription body article"><P>Ruth Gillen is a pianist who studied with the duo-pianists Vronsky and Babin, as well as with Konrad Wolff.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3dd85326